<template>
  <div class="py-3">
    <div class="tertiary--text text-body-2">
      {{ 
        $t(
        'fleet_management.agents.agent_detail.partials.card_field_select'
        )
      }}
    </div>
    <div class="mt-2 mb-2" v-if="!editMode">
      <v-chip class="mr-2">
        {{
          valueSelected === 'mrn:agent_condition:semi_detach'
            ? $t('fleet_management.agents.agent_detail.partials.only_unauthorized')
            : $t('fleet_management.agents.agent_detail.partials.all_events')
        }}
      </v-chip>
    </div>
    <v-select
      id="idEventosDesengancheSeleccionar"
      v-if="editMode"
      v-model="valueSelected"
      item-value="value"
      required
      dense
      filled
      hide-details="auto"
      item-text="text"
      :items="items"
      color="tertiary"
      @change="dueUndueChange"
      :readonly="isAgentDetail"
    >
      <template v-slot:item="data">
        <span
          style="color: #2B2B2B; font-family: Lato, sans-serif; font-size: 13px;"
          :id="data.item.domElementId"
        >
          {{ data.item.text }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'DueUndueSemiDetach',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      type: String,
      default: 'mrn:agent_condition:semi_detach_normal'
    }
  },
  components: {},
  data() {
    return {
      valueSelected: '',
      isAgentDetail: false,
      items: [
        {
          text: i18n.t('fleet_management.agents.agent_detail.partials.only_unauthorized'),
          value: 'mrn:agent_condition:semi_detach',
          domElementId: 'idEventosDesengancheIndebidos'
        },
        {
          text: i18n.t('fleet_management.agents.agent_detail.partials.all_events'),
          value: 'mrn:agent_condition:semi_detach_normal',
          domElementId: 'idEventosDesengancheTodos'
        }
      ]
    }
  },
  methods: {
    dueUndueChange(value) {
      this.$emit('dueUndueEmit', value)
    }
  },
  mounted() {
    this.$emit('dueUndueEmit', this.valueSelected)
    this.isAgentDetail = this.$route.name === 'AgentDetail'
  },
  computed: {},
  watch: {
    editMode() {
      if (this.editMode == false) {
        this.valueSelected = this.dataProp
      }
    }
  },
  created() {
    this.valueSelected = this.dataProp
  }
}
</script>

<style lang="scss" scoped></style>
